import React, { useEffect, useMemo, useState } from 'react'
import styles from './DocsList.module.scss'
import ContentHeader from 'components/UI/ContentHeader/ContentHeader'
import Document from './component/Document'
import Pagination from 'components/UI/Pagination/Pagination'
import SearchBooks from 'components/Modules/Ebook/Books/components/SearchBooks/SearchBooks'
import useLocalStorageFilter from 'helpers/useLocalStorageFilter'
import AsideFilterStore from 'components/UI/AsideFilter/asideFilterStore'
import useLocalization from 'hooks/useLocalization'
import FilterTextValues from 'components/UI/AsideFilter/FilterTextValues'
import AsideFilter from 'components/UI/AsideFilter/AsideFilter'
import { observer } from 'mobx-react'
import { superAxiosRequest } from 'axiosApi'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'

const initPagination = {
  page: 1,
  limit: 10,
}

const DocsList = (props) => {
  const {
    isOpenFilter,
    closeFilter,
    setTextValues,
    changeTextValue,
    filterTextValues,
  } = AsideFilterStore

  const typeProps = props.typeProps
  const queryParamsName =
    props.typeProps === 'template-list' ? 'search' : 'name'

  const [filteredDocs, setFilteredDocs] = useState([])
  const [listMenu, setListMenu] = useState([])
  const [docType, setDocType] = useState('')
  const [countItems, setCountItems] = useState(0)
  const [pagination, setPagination] = useState(initPagination)

  const history = useHistory()
  const [filter, updateFilter] = useLocalStorageFilter()

  const filterConfig = useMemo(() => {
    return typeProps === 'template-list'
      ? [
          {
            type: 'input',
            label: 'Поиск по названию',
            placeholder: 'Введите название',
            sort_key: 'name',
            nameState: queryParamsName,
          },
        ]
      : [
          {
            type: 'select',
            label: 'Статус',
            placeholder: 'Статус',
            values: [
              { id: 1, name: 'Подписанные' },
              { id: 0, name: 'На подписание' },
            ],
            sort_key: 'status',
            nameState: 'sms_code_confirmed',
          },
        ]
  }, [typeProps])

  const { translate } = useLocalization({
    section: 'ebooks',
    subsection: 'ebooks_books',
    dict: {
      edit: 'Edit',
      copy: 'Copy',
      delete: 'Delete',
      save: 'Save',
      filter: 'Filter',
      search: 'Search',
    },
  })

  const fetchDocuments = async () => {
    if (typeProps === 'template-list') {
      setListMenu([
        {
          name: `Отправить ${props.document.user}у`,
          action: 'send_to_user',
          perm: props.permission,
        },
        {
          name: 'Редактировать шаблон',
          action: 'edit_template',
          perm: props.permission,
        },
      ])

      const res = await superAxiosRequest({
        method: 'get',
        link: props.apiLink,
        params: {
          offset: (pagination.page - 1) * pagination.limit,
          limit: pagination.limit,
          ...filter,
        },
      })

      setDocType('template')
      setFilteredDocs(res.data.result)
      setCountItems(res.data._meta.count_items)
    } else {
      const res = await superAxiosRequest({
        method: 'get',
        link: props.apiLink,
        params: {
          offset: (pagination.page - 1) * pagination.limit,
          limit: pagination.limit,
          ...props.apiParams,
          ...filter,
        },
      })

      const signedData = res.data.result.filter(
        (item) => item[props.confirmField] === true,
      )
      const notSignedData = res.data.result.filter(
        (item) => item[props.confirmField] === false,
      )

      const combinedData = [...signedData, ...notSignedData]

      setDocType('all_req')
      setFilteredDocs(combinedData)
      setCountItems(res.data._meta.count_items)
    }
  }

  useEffect(() => {
    const url =
      typeProps === 'template-list'
        ? '/contract/template-list'
        : '/docs/all-requests'

    const unlisten = history.listen((location) => {
      if (location.pathname !== url) {
        updateFilter({})
      }
    })
    return () => {
      unlisten()
    }
  }, [history, updateFilter])

  useEffect(() => {
    return AsideFilterStore.unmountFilter
  }, [])

  useEffect(() => {
    fetchDocuments()
  }, [filter, pagination, typeProps, props.apiParams]) // eslint-disable-line

  const handleClearSearch = () => {
    const newFilter = { ...filter }
    delete newFilter[queryParamsName]
    updateFilter(newFilter)

    setTextValues(
      filterTextValues.filter((field) => field.key !== queryParamsName),
    )
    setPagination(initPagination)
  }

  const handleSearch = (searchValue) => {
    updateFilter({
      ...filter,
      [queryParamsName]: searchValue,
    })
    changeTextValue(queryParamsName, {
      key: queryParamsName,
      label: 'Поиск по названию',
      value: searchValue,
    })
    setPagination(initPagination)
  }

  return (
    <>
      <ContentHeader title={props.pageTitle}>
        <SearchBooks
          placeholder={
            props.typeProps === 'template-list'
              ? 'Введите название шаблона'
              : 'Введите ФИО, название шаблона или e-mail'
          }
          onSearch={handleSearch}
          onClear={handleClearSearch}
          translate={{ queryParamsName: 'Поиск', filter: 'Фильтр' }}
          value={filter?.[queryParamsName] || ''}
        />

        {!!filterTextValues.length && (
          <FilterTextValues
            onDelete={(key) => {
              const newFilter = { ...filter }
              delete newFilter[key]
              updateFilter(newFilter)
              setPagination(initPagination)
            }}
          />
        )}
      </ContentHeader>

      {isOpenFilter && (
        <AsideFilter
          getFilterParams={(newFilterParams) => {
            updateFilter(newFilterParams)
            setPagination({ ...pagination, page: 1 })
          }}
          config={filterConfig}
          filterValue={filter}
          onDropFilter={() => {
            updateFilter({})
            closeFilter()
            setPagination(initPagination)
          }}
          translate={translate}
        />
      )}

      <div className={styles.container}>
        <div className={styles.entries}>Entries: {countItems}</div>
        <div className={styles.documents}>
          {filteredDocs.map((item, key) => (
            <Document
              documentInfo={props.document}
              modalInfo={props.modal}
              docType={docType}
              key={key}
              listMenu={listMenu}
              confirmField={props.confirmField}
              userNameField={props.userNameField}
              data={item}
              showActionMenu={props.showActionMenu}
            />
          ))}
        </div>
      </div>

      <div className={styles.pagination}>
        <Pagination
          limit={pagination.limit}
          count={countItems}
          page={pagination.page}
          onChange={(page) => setPagination({ ...pagination, page })}
          onChangePerPage={(limit) => setPagination({ page: 1, limit })}
        />
      </div>
    </>
  )
}

export default observer(DocsList)
